"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.239 4.4a3.13 3.13 0 0 0-3.13 3.13c0 .745.285 1.443.765 2.006a.7.7 0 0 1-1.066.909C6.135 9.655 5.71 8.64 5.71 7.529A4.53 4.53 0 0 1 10.24 3h2.626a4.39 4.39 0 0 1 4.389 4.388.7.7 0 1 1-1.4 0 2.99 2.99 0 0 0-2.99-2.988zm5.948 9.338H20.3a.7.7 0 1 0 0-1.4H3.7a.7.7 0 1 0 0 1.4h10.036l.206.079a2.99 2.99 0 0 1 1.911 2.787v.007a2.99 2.99 0 0 1-2.989 2.989h-2.767a2.99 2.99 0 0 1-2.99-2.99.7.7 0 1 0-1.4 0 4.39 4.39 0 0 0 4.39 4.39h2.767a4.39 4.39 0 0 0 4.39-4.39v-.006a4.38 4.38 0 0 0-1.067-2.866",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=StrikeoutIcon24.js.map